import {
  Route,
  Routes,
  createBrowserRouter,
  createRoutesFromElements,
  useLocation,
} from 'react-router-dom';
import routes from '@/routes/index';
import LayoutDefault from '@/layouts/Default';
import ProposalLayout from '@/layouts/Proposal';
import EmptyDefault from '@/layouts/Empty';
import Main from '@/pages/Main';
import Settings from '@/pages/Settings';
import Error from '@/pages/Error';
import Rates from '@/pages/Settings/Rates';
import Mixes from '@/pages/Settings/Mixes';
import ReverseMortgage from '@/pages/Settings/ReverseMortgage';
import Login from '@/pages/Login';
import { useSelector } from 'react-redux';
import useRouteGuard from '@/hooks/useRouteGuard';
import useCheckLoginStatus from '@/hooks/useSessionChecker';
import Users from '@/pages/Settings/Users/UserList';
import UserCreate from '@/pages/Settings/Users/UserCreate';
import UserEdit from '@/pages/Settings/Users/UserEdit';
import MortgageCycleMixes from '@/pages/Settings/MortgageCycleMixes';
import Leads from '@/pages/Lead';
import Proposals from '@/pages/Proposals';
import ReverseRate from '@/pages/Settings/ReverseMortgageRates';
import Summary from '@/pages/Summary';
import MortgageCycleSummary from '@/pages/MortgageCycleSummary';
import Loading from '@/components/Loading';
import Clients from '@/pages/Clients';
import AdminProposals from '@/pages/AdminProposals';
import CustomizedMix from '@/pages/CustomizedMix';
import CustomizedMixSummary from '@/pages/CustomizedMixSummary';

const AppRoutes = () => {
  const location = useLocation();

  const userType = useSelector((state) => state.user.role.code);
  const allowallowedRoutes = useSelector((state) => state.user.role.allowallowedRoutes);

  useRouteGuard(allowallowedRoutes, userType);
  const isChecking = useCheckLoginStatus();
  if (isChecking) {
    return <Loading />;
  }

  return (
    <Routes location={location}>
      <Route path="/" errorElement={<Error />} >
        <Route element={<EmptyDefault />}>
          <Route path={routes.login.path} element={<Login />} />
        </Route>
        <Route element={<LayoutDefault />}>
          <Route path={routes.main.path} element={<Main />} />
          <Route path={routes.lead.path} element={<Leads />} />
          <Route path={routes.proposals.path} element={<Proposals />} />
          <Route path={routes.adminProposals.path} element={<AdminProposals />} />
          <Route path={routes.clients.path} element={<Clients />} />
          <Route path={routes.summary.path} element={<Summary />} />
          <Route path={routes.mortgageCycleSummary.path} element={<MortgageCycleSummary />} />
          <Route path={routes.customizedMix.path} element={<CustomizedMix />} />
          <Route path={routes.customizedMixSummary.path} element={<CustomizedMixSummary />} />
          <Route path={routes.settings.path} element={<Settings />} >
            <Route path={routes.settingsRates.path} element={<Rates />} />
            <Route path={routes.settingsMixes.path} element={<Mixes />} />
            <Route path={routes.settingsReverse.path} element={<ReverseMortgage />} />
            <Route path={routes.settingsReverseRates.path} element={<ReverseRate />} />
            <Route path={routes.settingsMortgageCycleMixes.path} element={<MortgageCycleMixes />} />
            <Route path={routes.settingsUsers.path} element={<Users />} />
            <Route path={routes.settingsCreateUser.path} element={<UserCreate />} />
            <Route path={routes.settingsEditUser.path} element={<UserEdit />} />
          </Route>
          <Route path={routes.newProposal.path} element={<ProposalLayout />}>
            {routes.newProposal.pages.map((route) => (
              <Route
                key={route.name}
                path={route.path}
                element={route.element}
              />
            ))}
          </Route>
        </Route>
      </Route>
    </Routes>
  );
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/*" element={<AppRoutes />} />,
  ),
);

export default router;
